import React from "react";
import {useTranslation} from "react-i18next";

const PasswordValidationPane = ({field, style}) => {
    const { t } = useTranslation();

    return (
        <div id="message" style={style}>
            <p><b>{t('CONTENT.USER.PASSWORD-MUST-CONTAIN')}</b></p>
            <>
            {field === "password" ? (
                <>
                    <p id="letter" className="invalid">{t('CONTENT.USER.PASSWORD-LOWERCASE')}</p>
                    <p id="capital" className="invalid">{t('CONTENT.USER.PASSWORD-UPPERCASE')}</p>
                    <p id="number" className="invalid">{t('CONTENT.USER.PASSWORD-NUMBER')}</p>
                    <p id="length" className="invalid">{t('CONTENT.USER.PASSWORD-LENGTH')}</p>
                    <p id="special" className="invalid">{t('CONTENT.USER.PASSWORD-SPECIAL')}</p>
                </>
            ) : (
                <p id="match" className="invalid">{t('CONTENT.USER.PASSWORD-MATCH')}</p>
            )}
            </>
        </div>
    );
}
export default PasswordValidationPane;
